
import React from "react";
import { CheckCircle, LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { Helmet } from "react-helmet";

interface ThankYouProps {
  title: string;
  message: string;
  ctaText?: string;
  ctaUrl?: string;
  secondaryCtaText?: string;
  secondaryCtaUrl?: string;
  pageTitle?: string;
  icon?: LucideIcon;
  showForm?: boolean;
  form?: React.ReactNode;
}

export function ThankYou({
  title,
  message,
  ctaText = "Return to Homepage",
  ctaUrl = "/",
  secondaryCtaText,
  secondaryCtaUrl,
  pageTitle = "Thank You | Grandpal",
  icon: Icon = CheckCircle,
  showForm = false,
  form,
}: ThankYouProps) {
  return (
    <Layout>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <div className="min-h-[70vh] flex items-center justify-center py-12">
        <div className="container max-w-lg text-center">
          <div className="mb-6 flex justify-center">
            <div className="rounded-full bg-grandpal-green-lighter p-3">
              <Icon className="h-12 w-12 text-grandpal-green" />
            </div>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-semibold mb-6">{title}</h1>
          <p className="text-lg text-grandpal-gray mb-8">{message}</p>
          
          {showForm ? (
            <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm mb-8">
              <h2 className="text-xl font-semibold mb-4">Create Your Account</h2>
              {form}
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
              <Button asChild size="lg">
                <Link to={ctaUrl}>{ctaText}</Link>
              </Button>
              
              {secondaryCtaText && secondaryCtaUrl && (
                <Button variant="outline" asChild size="lg">
                  <Link to={secondaryCtaUrl}>{secondaryCtaText}</Link>
                </Button>
              )}
            </div>
          )}
          
          {showForm && (
            <div className="mt-6">
              <Button variant="outline" asChild size="lg">
                <Link to={ctaUrl}>{ctaText}</Link>
              </Button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
